module.exports = __webpack_public_path__ + "img/loyal.430c7281.svg";